import * as yup from 'yup';

import { checkSINValidity } from '../../../components/T4Slip/T4SlipSetup/validator';

// export const RL3SlipSetupValidationSchema = yup.object({
//   recipientType: yup.number().nullable().required("Recipient Type is required"),
//   initials: yup.string().nullable()
//     .when('recipientType', {
//       is: (value:number) => value === 10 || value === 20 || value === 60 || value === 70,
//       then: yup.string().max(1, "maximum one character"),
//       otherwise: yup.string().nullable()
//     }),
//   name1: yup.string().nullable()
//     .when('recipientType', {
//       is: (value:number) => value === 10 || value === 20 || value === 60 || value === 70,
//       then: yup.string().required('First Name is required').max(12, "First Name has at most 12 characters"),
//       otherwise: yup.string().nullable()
//     }),
//   name2: yup.string().nullable()
//     .when('recipientType', {
//       is: (value:number) => value === 10 || value === 20 || value === 60 || value === 70,
//       then: yup.string().nullable().required('Last Name is required').max(20, "Last Name has at most 20 characters"),
//       otherwise: yup.string().nullable()
//     }),
//   secondRecipientName: yup.string().nullable()
//     .when('recipientType', {
//       is: (value:number) => value === 20 || value === 60 || value === 70,
//       then: yup.string().nullable().required('Second Recipient Name is required'),
//       otherwise: yup.string().nullable()
//     }),
//   firstLineOfRecipientName: yup.string().nullable()
//     .when('recipientType', {
//       is: (value:number) => value === 30 || value === 40 || value === 50,
//       then: yup.string().nullable().required('First Line Of Recipient Name is required').max(12, "First Line Of Recipient Name has at most 12 characters"),
//       otherwise: yup.string().nullable()
//     }),
//     secondLineOfRecipientName: yup.string().nullable()
//     .when('recipientType', {
//       is: (value:number) => value === 30 || value === 40 || value === 50,
//       then: yup.string().nullable().required('Second Line Of Recipient Name is required'),
//       otherwise: yup.string().nullable()
//     }),

    
//     addressLine1: yup
//     .string()
//     .required("Address is required")
//     .max(50, "Address has at most 50 characters"),

//   city: yup
//     .string()
//     .required("City is required")
//     .max(28, "City has at most 28 characters"),
//   bankTransit: yup
//     .string()
//     .max(10, "Bank Transit has at most 10 characters"),
//     otherIdentificationNumber: yup
//     .string()
//     .max(16, "Other Identification Number has at most 16 characters"),

//   province: yup.string().nullable().required("Province is required"),
//   // provinceOfEmployment: yup.string().nullable().required("Province of employment is required"),

//   postalCode: yup
//     .string()
//     .required("PostCode is required"),

//   country: yup.mixed().test(
//     'is-string-or-object',
//     'Input must be a string or an object.',
//     (value) => typeof value === 'string' || typeof value === 'object'
//   ).required("Country is required"),

//   slipType: yup.number().required("slipType is required"),

//   slipStatus: yup.number().required("slip Status is required"),


//   transit: yup
//   .string().nullable()
//   .max(8, "Transit has at most 8 characters"),
//   optionalTextToPrintOnTheSlip: yup
//   .string().nullable()
//   .max(11, "Optional Text has at most 11 characters"),
// recipientAccount: yup
//   .string().nullable()
//   .max(12, "Recipient Account has at most 12 characters"),

//   uniqueIdentifier: yup.string().nullable()
//     .when('recipientType', {
//       is: (value:number) => value === 10 || value === 20 || value === 60 || value === 70,
//       then:yup.string().nullable().test(
//       'is-masked-or-not',
//       'Invalid value',
//       function (value:any) {
//         let sin = value && value.replace(/-/g, '')
//         const output = checkSINValidity(sin);
   
//         let maxLength = 11;
  
//         if (value && value.charAt(2) === '*') {
//           maxLength = 7;
//           if (value && value.length == maxLength) {
//             return true;
//           } else {
//             return this.createError({
//               message: 'Invalid Social Insuarance Number',
//               path: this.path,
//             });
//           }
//         } else {
//           if (value && value.length == maxLength && output % 10 === 0) {
//             return true;
//           } else {
//             return this.createError({
//               message: 'Invalid Social Insuarance Number',
//               // message: 'Social Insuarance Number has at least 9 characters',
//               path: this.path,
//             });
//           }
//         }
//       }
//     ).required('Social Insuarance is required'),
//     otherwise: yup.string().nullable()
//     }),

//   businessNumber: yup.string().nullable()
//     .when('recipientType', {
//       is: (value:number) => value === 30 || value === 50,
//       then:yup.string().test(
//           'is-valid-or-not',
//           'Invalid value',
//           function (value:any) {
//             let maxLength = 15;
       
//             const firstNineDigits: string = value && value.substring(0, 9);
           
//             const output = checkSINValidity(firstNineDigits);
        
            
//               if (value && value.length == maxLength && output % 10 === 0) {
//                 return true;
//               } else {
//                 return this.createError({
//                   message: 'Invalid Business Number',
//                   path: this.path,
//                 });
//               }
//           }
//         ).nullable().required('business Number is required'),
//     otherwise: yup.string().nullable()
//     }),

//   trustAccountNumber: yup.string().nullable()
//     .when('recipientType', {
//       is: 40,
//       then:yup.string().required('Trust Account Number is required'),
//     otherwise: yup.string().nullable()
//     }),

//     email: yup
//     .string().nullable()
//     .email("Please enter valid Email"),
// });

export const RL3SlipSetupValidationSchema = yup.object({
  // recipientType: yup
  //   .number()
  //   .nullable()
  //   .required("Recipient Type is required"),

  // initials: yup.string().nullable().when("recipientType", (recipientType:any, schema) => {
  //   if ([10, 20, 60, 70].includes(recipientType)) {
  //     return schema.max(1, "Maximum one character");
  //   }
  //   return schema.nullable();
  // }),

  // name1: yup.string().nullable().when("recipientType", (recipientType:any, schema) => {
  //   if ([10, 20, 60, 70].includes(recipientType)) {
  //     return schema.required("First Name is required").max(12, "First Name has at most 12 characters");
  //   }
  //   return schema.nullable();
  // }),

  // name2: yup.string().nullable().when("recipientType", (recipientType:any, schema) => {
  //   if ([10, 20, 60, 70].includes(recipientType)) {
  //     return schema.required("Last Name is required").max(20, "Last Name has at most 20 characters");
  //   }
  //   return schema.nullable();
  // }),

  // secondRecipientName: yup.string().nullable().when("recipientType", (recipientType:any, schema) => {
  //   if ([20, 60, 70].includes(recipientType)) {
  //     return schema.required("Second Recipient Name is required");
  //   }
  //   return schema.nullable();
  // }),

  // firstLineOfRecipientName: yup.string().nullable().when("recipientType", (recipientType:any, schema) => {
  //   if ([30, 40, 50].includes(recipientType)) {
  //     return schema.required("First Line Of Recipient Name is required").max(12, "First Line Of Recipient Name has at most 12 characters");
  //   }
  //   return schema.nullable();
  // }),

  // secondLineOfRecipientName: yup.string().nullable().when("recipientType", (recipientType:any, schema) => {
  //   if ([30, 40, 50].includes(recipientType)) {
  //     return schema.required("Second Line Of Recipient Name is required");
  //   }
  //   return schema.nullable();
  // }),

  // addressLine1: yup
  //   .string()
  //   .required("Address is required")
  //   .max(50, "Address has at most 50 characters"),

  // city: yup
  //   .string()
  //   .required("City is required")
  //   .max(28, "City has at most 28 characters"),

  // bankTransit: yup
  //   .string()
  //   .max(10, "Bank Transit has at most 10 characters"),

  // otherIdentificationNumber: yup
  //   .string()
  //   .max(16, "Other Identification Number has at most 16 characters"),

  // province: yup
  //   .string()
  //   .nullable()
  //   .required("Province is required"),

  // postalCode: yup
  //   .string()
  //   .required("Postal Code is required"),

  // country: yup
  //   .mixed()
  //   .test(
  //     "is-string-or-object",
  //     "Input must be a string or an object.",
  //     (value) => typeof value === "string" || typeof value === "object"
  //   )
  //   .required("Country is required"),

  // slipType: yup
  //   .number()
  //   .required("Slip Type is required"),

  // slipStatus: yup
  //   .number()
  //   .required("Slip Status is required"),

  // transit: yup
  //   .string()
  //   .nullable()
  //   .max(8, "Transit has at most 8 characters"),

  // optionalTextToPrintOnTheSlip: yup
  //   .string()
  //   .nullable()
  //   .max(11, "Optional Text has at most 11 characters"),

  // recipientAccount: yup
  //   .string()
  //   .nullable()
  //   .max(12, "Recipient Account has at most 12 characters"),

  // uniqueIdentifier: yup.string().when("recipientType", (recipientType:any, schema) => {
  //   if ([10, 20, 60, 70].includes(recipientType)) {
  //     return schema
  //       .test("is-masked-or-not", "Invalid value", function (value: any) {
  //         if (!value) {
  //           return this.createError({
  //             message: "Social Insurance Number is required",
  //             path: this.path,
  //           });
  //         }

  //         const sin = value.replace(/-/g, "");
  //         const isMasked = value.charAt(2) === "*";
  //         const maxLength = isMasked ? 7 : 11;
  //         const output = checkSINValidity(sin);

  //         if (value.length !== maxLength) {
  //           return this.createError({
  //             message: "Invalid Social Insurance Number",
  //             path: this.path,
  //           });
  //         }

  //         if (!isMasked && output % 10 !== 0) {
  //           return this.createError({
  //             message: "Invalid Social Insurance Number",
  //             path: this.path,
  //           });
  //         }

  //         return true;
  //       })
  //       .required("Social Insurance Number is required");
  //   }
  //   return schema.nullable();
  // }),

  // businessNumber: yup.string().when("recipientType", (recipientType:any, schema) => {
  //   if ([30, 50].includes(recipientType)) {
  //     return schema
  //       .test("is-valid-or-not", "Invalid value", function (value: any) {
  //         if (!value) {
  //           return this.createError({
  //             message: "Business Number is required",
  //             path: this.path,
  //           });
  //         }

  //         const firstNineDigits = value.substring(0, 9);
  //         const output = checkSINValidity(firstNineDigits);

  //         if (value.length === 15 && output % 10 === 0) {
  //           return true;
  //         }

  //         return this.createError({
  //           message: "Invalid Business Number",
  //           path: this.path,
  //         });
  //       })
  //       .required("Business Number is required");
  //   }
  //   return schema.nullable();
  // }),

  // trustAccountNumber: yup.string().when("recipientType", (recipientType:any, schema) => {
  //   if (recipientType === 40) {
  //     return schema.required("Trust Account Number is required");
  //   }
  //   return schema.nullable();
  // }),

  // email: yup
  //   .string()
  //   .nullable()
  //   .email("Please enter a valid Email"),

  recipientType: yup
    .number()
    .nullable()
    .required("Recipient Type is required"),

  initials: yup
    .string()
    .nullable()
    .test("initials-validation", "Maximum one character", function (value) {
      const { recipientType } = this.parent;
      if ([10, 20, 60, 70].includes(recipientType)) {
        if (!value) return true;
        return value.length <= 1 || this.createError({ message: "Maximum one character" });
      }
      return true;
    }),

  name1: yup
    .string()
    .nullable()
    .test("name1-validation", "Invalid value", function (value) {
      const { recipientType } = this.parent;
      if ([10, 20, 60, 70].includes(recipientType)) {
        if (!value) return this.createError({ message: "First Name is required" });
        if (value.length > 12) return this.createError({ message: "First Name has at most 12 characters" });
      }
      return true;
    }),

  name2: yup
    .string()
    .nullable()
    .test("name2-validation", "Invalid value", function (value) {
      const { recipientType } = this.parent;
      if ([10, 20, 60, 70].includes(recipientType)) {
        if (!value) return this.createError({ message: "Last Name is required" });
        if (value.length > 20) return this.createError({ message: "Last Name has at most 20 characters" });
      }
      return true;
    }),

  secondRecipientName: yup
    .string()
    .nullable()
    .test("secondRecipientName-validation", "Invalid value", function (value) {
      const { recipientType } = this.parent;
      if ([20, 60, 70].includes(recipientType)) {
        if (!value) return this.createError({ message: "Second Recipient Name is required" });
      }
      return true;
    }),

  firstLineOfRecipientName: yup
    .string()
    .nullable()
    .test("firstLineOfRecipientName-validation", "Invalid value", function (value) {
      const { recipientType } = this.parent;
      if ([30, 40, 50].includes(recipientType)) {
        if (!value) return this.createError({ message: "First Line Of Recipient Name is required" });
        if (value.length > 12)
          return this.createError({ message: "First Line Of Recipient Name has at most 12 characters" });
      }
      return true;
    }),

  secondLineOfRecipientName: yup
    .string()
    .nullable()
    .test("secondLineOfRecipientName-validation", "Invalid value", function (value) {
      const { recipientType } = this.parent;
      if ([30, 40, 50].includes(recipientType)) {
        if (!value) return this.createError({ message: "Second Line Of Recipient Name is required" });
      }
      return true;
    }),

  addressLine1: yup
    .string()
    .required("Address is required")
    .max(50, "Address has at most 50 characters"),

  city: yup
    .string()
    .required("City is required")
    .max(28, "City has at most 28 characters"),

  bankTransit: yup.string().nullable().max(10, "Bank Transit has at most 10 characters"),

  otherIdentificationNumber: yup
    .string().nullable()
    .max(16, "Other Identification Number has at most 16 characters"),

  province: yup
    .string()
    .nullable()
    .required("Province is required"),

  postalCode: yup
    .string()
    .required("Postal Code is required"),

  country: yup
    .mixed()
    .test("is-string-or-object", "Input must be a string or an object.", (value) =>
      typeof value === "string" || typeof value === "object"
    )
    .required("Country is required"),

  slipType: yup.number().required("Slip Type is required"),

  slipStatus: yup.number().required("Slip Status is required"),

  transit: yup.string().nullable().max(8, "Transit has at most 8 characters"),

  optionalTextToPrintOnTheSlip: yup
    .string()
    .nullable()
    .max(11, "Optional Text has at most 11 characters"),

  recipientAccount: yup
    .string()
    .nullable()
    .max(12, "Recipient Account has at most 12 characters"),

  uniqueIdentifier: yup
    .string()
    .nullable()
    .test("uniqueIdentifier-validation", "Invalid SIN", function (value) {
      const { recipientType } = this.parent;
      if (![10, 20, 60, 70].includes(recipientType)) return true;
      if (!value) return this.createError({ message: "Social Insurance Number is required" });

      const sin = value.replace(/-/g, "");
      const isMasked = value.charAt(2) === "*";
      const maxLength = isMasked ? 7 : 11;
      const output = checkSINValidity(sin);

      if (value.length !== maxLength)
        return this.createError({ message: "Invalid Social Insurance Number" });

      if (!isMasked && output % 10 !== 0)
        return this.createError({ message: "Invalid Social Insurance Number" });

      return true;
    }),

  businessNumber: yup
    .string()
    .nullable()
    .test("businessNumber-validation", "Invalid BN", function (value) {
      const { recipientType } = this.parent;
      if (![30, 50].includes(recipientType)) return true;

      if (!value) return this.createError({ message: "Business Number is required" });

      const firstNineDigits = value.substring(0, 9);
      const output = checkSINValidity(firstNineDigits);

      if (value.length !== 15 || output % 10 !== 0)
        return this.createError({ message: "Invalid Business Number" });

      return true;
    }),

  trustAccountNumber: yup
    .string()
    .nullable()
    .test("trustAccountNumber-validation", "Invalid Trust Account Number", function (value) {
      const { recipientType } = this.parent;
      if (recipientType === 40 && !value)
        return this.createError({ message: "Trust Account Number is required" });
      return true;
    }),

  email: yup.string().nullable().email("Please enter a valid Email"),
});
